import api from './api';

const compOffService = {
  /**
   * Submit a comp-off claim
   */
  createClaim: async (workDate, reason, isHalfDay = false) => {
    const response = await api.post('/comp-off/claim', { workDate, reason, isHalfDay });
    return response;
  },

  /**
   * Get user's comp-off claims
   */
  getMyClaims: async () => {
    const response = await api.get('/comp-off/my-claims');
    return response.data;
  },

  /**
   * Get comp-off balance
   */
  getBalance: async () => {
    const response = await api.get('/comp-off/balance');
    return response.data;
  },

  /**
   * Get pending claims (for managers)
   */
  getPendingClaims: async (filters = {}) => {
    const response = await api.get('/comp-off/pending', { params: filters });
    return response.data;
  },

  /**
   * Get all claims (for managers)
   */
  getAllClaims: async (filters = {}) => {
    const response = await api.get('/comp-off/all', { params: filters });
    return response.data;
  },

  /**
   * Approve a comp-off claim
   */
  approveClaim: async (claimId, comments = '') => {
    const response = await api.put(`/comp-off/${claimId}/approve`, { comments });
    return response.data;
  },

  /**
   * Reject a comp-off claim
   */
  rejectClaim: async (claimId, comments = '') => {
    const response = await api.put(`/comp-off/${claimId}/reject`, { comments });
    return response.data;
  },

  /**
   * Settle an approved comp-off (paid or leave_taken)
   */
  settleClaim: async (claimId, settlementType) => {
    const response = await api.put(`/comp-off/${claimId}/settle`, { settlementType });
    return response.data;
  },

  /**
   * Get statistics
   */
  getStatistics: async () => {
    const response = await api.get('/comp-off/statistics');
    return response.data;
  }
};

export default compOffService;
